// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Weekday from "../../../to-be-migrated/domain/types/common/Weekday.bs.js";
import * as Belt_Array from "../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as FilterType from "../entity/FilterType.bs.js";
import * as Caml_option from "../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CampaignStatusType from "../entity/CampaignStatusType.bs.js";
import * as Timestamp$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as ZoneClusterCampaignApiModel from "../api-model/ZoneClusterCampaignApiModel.bs.js";

function convertMetersToKms(distance_in_meters) {
  return distance_in_meters / 1000.0;
}

function apiModelToState(res) {
  return {
          campaigns: List.map((function (campaign) {
                  var match = campaign.zone_ids.length;
                  var value = campaign.pending_priority;
                  var value$1 = campaign.effective_till;
                  var match$1 = FilterType.fromString(campaign.sub_type);
                  var tmp;
                  if (match$1 !== 1) {
                    var value$2 = campaign.values.auto;
                    var value$3 = campaign.values.manual;
                    var value$4 = campaign.values.radius_delta;
                    tmp = {
                      auto: value$2 !== undefined ? value$2 / 1000.0 : ErrorUtils$Catalyst.raiseError("ZoneClusterCampaignEntityMapper.res", "Filter value 'auto' is missing for filter type " + campaign.sub_type, ""),
                      manual: value$3 !== undefined ? value$3 / 1000.0 : ErrorUtils$Catalyst.raiseError("ZoneClusterCampaignEntityMapper.res", "Filter value 'manual' is missing for filter type " + campaign.sub_type, ""),
                      threshold: undefined,
                      ratio: undefined,
                      radius_delta: value$4 !== undefined ? value$4 / 1000.0 : undefined
                    };
                  } else {
                    var value$5 = campaign.values.threshold;
                    var match$2 = campaign.values.ratio;
                    var value$6 = campaign.values.radius_delta;
                    tmp = {
                      auto: undefined,
                      manual: undefined,
                      threshold: value$5 !== undefined ? value$5 / 1000.0 : ErrorUtils$Catalyst.raiseError("ZoneClusterCampaignEntityMapper.res", "Filter value 'threshold' is missing for filter type " + campaign.sub_type, ""),
                      ratio: match$2 !== undefined ? campaign.values.ratio : ErrorUtils$Catalyst.raiseError("ZoneClusterCampaignEntityMapper.res", "Filter value 'ratio' is missing for filter type " + campaign.sub_type, ""),
                      radius_delta: value$6 !== undefined ? value$6 / 1000.0 : undefined
                    };
                  }
                  var approval_info = campaign.approval_info;
                  var validations = campaign.validation;
                  return {
                          id: campaign.id,
                          name: campaign.name,
                          geo_region_id: campaign.geo_region_id,
                          vehicle_id: campaign.vehicle_id,
                          _type: campaign._type,
                          sub_type: FilterType.fromString(campaign.sub_type),
                          zone_ids: match !== 0 ? campaign.zone_ids : ErrorUtils$Catalyst.raiseError("ZoneClusterCampaignEntityMapper.res", "Zone IDs array cannot be empty", ""),
                          cluster_ids: campaign.cluster_ids,
                          status: CampaignStatusType.fromString(campaign.status),
                          priority: campaign.priority,
                          pending_priority: value !== undefined ? value : campaign.priority,
                          effective_from: Timestamp$Catalyst.make(campaign.effective_from),
                          effective_till: value$1 !== undefined ? Caml_option.some(Timestamp$Catalyst.make(value$1)) : undefined,
                          days_of_week: List.map((function (day) {
                                  return Weekday.fromString(day.toLowerCase());
                                }), campaign.days_of_week),
                          day_start_hour: campaign.day_start_hour,
                          day_start_min: campaign.day_start_min,
                          day_end_hour: campaign.day_end_hour,
                          day_end_min: campaign.day_end_min,
                          values: tmp,
                          creation_info: {
                            actor: {
                              name: campaign.creation_info.actor.name,
                              email_id: campaign.creation_info.actor.email_id
                            },
                            time: Timestamp$Catalyst.make(campaign.creation_info.time)
                          },
                          approval_info: approval_info !== undefined ? ({
                                actor: {
                                  name: approval_info.actor.name,
                                  email_id: approval_info.actor.email_id
                                },
                                time: Timestamp$Catalyst.make(approval_info.time)
                              }) : undefined,
                          validation: validations !== undefined ? ({
                                validations: Belt_Array.map(validations.validations, (function (validation) {
                                        return {
                                                validation_type: validation.validation_type,
                                                segment_names: validation.segment_names
                                              };
                                      }))
                              }) : undefined
                        };
                }), res.campaigns),
          total_count: res.total_count
        };
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(ZoneClusterCampaignApiModel.t_decode(json), "ZoneClusterCampaignEntityMapper.res"));
}

export {
  convertMetersToKms ,
  apiModelToState ,
  execute ,
  
}
/* Timestamp-Catalyst Not a pure module */
